import type { FormDescriptor, FormField } from '@funkit/connect-core'

import { isIdentityField } from './formLayout'

/**
 * The contract describes requested fields, rather than exposing an L1/L2 flag.
 * A later round may re-ask for a birth date beside its declarations, so that
 * one identity field alone does not make the round an identity round.
 */
export function isAdditionalKycForm(form: FormDescriptor): boolean {
  const identityFields = form.fields.filter(isIdentityField)
  if (identityFields.length === form.fields.length) {
    return false
  }
  return identityFields.every(isBirthDate)
}

const isBirthDate = (field: FormField): boolean => field.id === 'DATE_OF_BIRTH'
